import { render } from "./DataApp.vue?vue&type=template&id=544788b6"
import script from "./DataApp.vue?vue&type=script&lang=js"
export * from "./DataApp.vue?vue&type=script&lang=js"

import "./DataApp.vue?vue&type=style&index=0&id=544788b6&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__